const XYD_PRODUCT_IDS = ['XYD-FPD', 'XYD-WSB', 'YYFAX-FPD'];
const XYD_FPD_PRODUCT_ID = 'XYD-FPD';
const XYD_FWXY_CONTRACT = {
  text: '企业经营测评服务协议',
  value: 'xyd_fwxy',
  protocolName: '企业经营测评服务协议',
};
const XYD_CONTRACT_VALUES = ['xyd_zc', 'xyd_xxbh', 'xyd_clxq', 'xyd_gxsq', 'xyd_fwxy'];

const XYD_CONTRACT_GROUP_DEFS = [
  {
    value: 'xyd_all_protocols',
    values: ['xyd_zc', 'xyd_xxbh', 'xyd_clxq', 'xyd_gxsq', 'xyd_fwxy'],
  },
];

export function isXydProduct(productId = '') {
  return XYD_PRODUCT_IDS.includes(productId);
}

export function enhanceXydContractConfig(item, productId) {
  if (!isXydProduct(productId) || item.type !== 'Contract') {
    return item;
  }
  const configuredContractList = item.props?.list || [];
  const hasCreditReportAgreement = configuredContractList.some(
    (contract) => normalizeContractValue(contract.value) === XYD_FWXY_CONTRACT.value,
  );
  const contractList = productId === XYD_FPD_PRODUCT_ID && !hasCreditReportAgreement
    ? [...configuredContractList, XYD_FWXY_CONTRACT]
    : configuredContractList;
  return {
    ...item,
    type: 'XydContractGroup',
    props: {
      ...item.props,
      defaultCheck: false,
      list: buildXydContractGroups(contractList),
    },
    validate: [
      ...(item.validate || []),
      {
        required: true,
        message: '请先勾选全部协议',
        pattern: ['^true$'],
      },
    ],
  };
}

export function getChannelTaxFlag(data = {}) {
  const flag = data.channelTaxFlag ?? data.taxFlag ?? data.invoiceTaxFlag;
  return ['0', '1', '2', 0, 1, 2].includes(flag) ? `${flag}` : '2';
}

export function getChannelTaxLabel(data = {}) {
  const flag = getChannelTaxFlag(data);
  const labelMap = {
    0: '有税',
    1: '无税',
    2: '未知',
  };
  return labelMap[flag] || labelMap[2];
}

export function buildXydAgreementLog({ productId, formData = {}, submitInfo = {}, contractList = [] }) {
  if (!isXydProduct(productId)) {
    return {};
  }
  const mobile = formData.borrowerPhone || formData.phone || submitInfo.borrowerPhone || submitInfo.applyPhone || submitInfo.phone || '';
  const customerId = submitInfo.customerId || submitInfo.userId || submitInfo.applyUserId || submitInfo.custId || '';
  const agreeTime = formatDate(new Date());
  const selectedContracts = flattenXydContracts(contractList);
  const recordInfo = selectedContracts
    .filter((contract) => XYD_CONTRACT_VALUES.includes(normalizeContractValue(contract.value)))
    .map((contract) => ({
      agreeMode: 'AGREE',
      agreeTime,
      agreeResult: 'Y',
      protocolName: contract.protocolName || contract.text,
      version: '1.0',
    }));

  if (!recordInfo.length) {
    return {};
  }

  return {
    channelTaxFlag: getChannelTaxFlag({ ...submitInfo, ...formData }),
    agreementLog: {
      mobile,
      customerId,
      recordInfo,
    },
  };
}

export function flattenXydContracts(contractList = []) {
  const flattenedList = contractList.reduce((result, contract) => {
    if (Array.isArray(contract.contracts)) {
      return result.concat(contract.contracts);
    }
    return result.concat(contract);
  }, []);
  const valueSet = new Set();
  return flattenedList.filter((contract) => {
    const value = normalizeContractValue(contract.value);
    if (valueSet.has(value)) {
      return false;
    }
    valueSet.add(value);
    return true;
  });
}

export function buildXydTypeList(productId, contractList = [], options = {}) {
  const { excludeAuthorization = false } = options;
  const isXydContractList = contractList
    .some((contract) => XYD_CONTRACT_VALUES.includes(normalizeContractValue(contract.value)));
  const shouldExcludeAuthorization = excludeAuthorization
    && (isXydProduct(productId) || isXydContractList);
  return contractList
    .filter((contract) => !shouldExcludeAuthorization
      || normalizeContractValue(contract.value) !== 'bw_sq')
    .map((contract) => contract.value);
}

function buildXydContractGroups(contractList = []) {
  const xydValueSet = new Set(XYD_CONTRACT_VALUES);
  const normalGroups = contractList
    .filter((contract) => !xydValueSet.has(normalizeContractValue(contract.value)))
    .map((contract) => ({
      value: contract.value,
      contracts: [contract],
    }));
  const xydGroups = XYD_CONTRACT_GROUP_DEFS
    .map((group) => ({
      value: group.value,
      contracts: group.values
        .map((value) => contractList.find((contract) => normalizeContractValue(contract.value) === value))
        .filter(Boolean),
    }))
    .filter((group) => group.contracts.length);
  return [...normalGroups, ...xydGroups];
}

function normalizeContractValue(value = '') {
  return `${value}`.toLowerCase();
}

function formatDate(date) {
  const pad = (num) => `${num}`.padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
